import { useState } from "react";

import clsx from "clsx";

import { Drawer, DrawerHeader } from "@components/v2";
import { type CellContext } from "@tanstack/react-table";
import { generateAnonBase64Hash } from "@utils/anonymous";
import { usePrefs } from "@utils/client-side-preferences";

import { useSelectedConversionEventId } from "../hooks/use-orders-filters";
import { OrderDetailsContent } from "../order-details-drawer/order-details-content";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
}

interface ConversionEvent {
  conversionEventId: string;
  hash: string;
  isAnon: boolean;
}

const OrderIdFormatter = <TData,>(props: TableCellProps<TData>) => {
  const row = props.cell.row.original;
  const [conversionEventId, setConversionEventId] =
    useSelectedConversionEventId();
  const [isDrawerOpen, setIsDrawerOpen] = useState(
    !!conversionEventId &&
      (row as ConversionEvent).conversionEventId === conversionEventId,
  );

  const prefs = usePrefs();
  const isAnon = prefs.isDemoMode;
  return (
    <>
      <div
        onClick={() => {
          setIsDrawerOpen(true);
          const value = (row as ConversionEvent).conversionEventId;
          setConversionEventId(value);
        }}
        className={clsx(
          "border-r border-v2-tertiary px-4 py-2.5 bg-inherit font-mono text-sm text-v2-action tracking-[0.25px] cursor-pointer break-all",
        )}
        title={String(props.cell.getValue())}
      >
        {isAnon
          ? generateAnonBase64Hash({
              value: props.cell.getValue() as string,
              prefix: "orderId",
              doAnon: isAnon,
            })
          : String(props.cell.getValue())}
      </div>
      <Drawer
        bodyClassName="h-full flex flex-col gap-4"
        isOpen={isDrawerOpen}
        onClose={() => {
          setConversionEventId(undefined);
          setIsDrawerOpen(false);
        }}
      >
        <DrawerHeader
          onClose={() => {
            setConversionEventId(undefined);
            setIsDrawerOpen(false);
          }}
        >
          Order #{String(props.cell.getValue())}
        </DrawerHeader>
        <OrderDetailsContent
          conversionEventId={
            conversionEventId || (row as ConversionEvent).conversionEventId
          }
        />
      </Drawer>
    </>
  );
};

export default OrderIdFormatter;
